import React from 'react';
import get from 'lodash.get';
import clsx from 'clsx';

// components
import { GroupedButtons } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { AddEmployeeCta } from 'page_modules/business-pdp/utils';
import ApplyAndUpgradeCtas from 'src/universal/components/ApplyOrUpgradeCta';

// Utils
import { createDtmHandler } from 'src/universal/utils/analyticsTracking';
import { getUpgradeCtaProps } from 'src/universal/utils/orchestraUtils';

// Styles

import styles from './__styles__/index.scss?modules';

const HeroEventKey = 'Hero';
const deltaEventKey = 'DeltaPlat-HeroBanner';

const buildDisclaimerList = (
  links,
  parent = '',
  customKeys,
  manipulateDtmString = false,
  shortName
) => {
  const keyList = customKeys || ['offerTerms', 'ratesFees'];
  return keyList.map((linkType = '') => {
    const dtmObj =
      (get(links, `${linkType}.dtm`) && {
        ...links[linkType].dtm,
        eventAsset: manipulateDtmString
          ? `${parent}-${linkType}`
          : `${links[linkType].dtm.eventAsset}_${parent}`
      }) ||
      {};
    return {
      className: shortName === 'gold' ? styles.focusDark : styles.focusLight,
      url: get(links, `${linkType}.url`) || '',
      text: <Sanitizer safelySetInnerHTML={get(links, `${linkType}.text`) || ''} />,
      target: '_blank',
      onClick: createDtmHandler({
        dtmObj
      }),
      qeId: 'offerBox-disclaimer-links'
    };
  });
};

export const buildCtaAndLinks = (cardInfo, links) => {
  const {
    currentCard: { shortName }
  } = cardInfo;
  const { needUpgradeCta } = getUpgradeCtaProps(
    links,
    get(cardInfo, 'currentCard.pznOffer'),
    cardInfo.isGCSMember || cardInfo.isGCSLegacy
  );
  const customTncKeys = needUpgradeCta
    ? ['offerTermsUpgrade', 'ratesFeesUpgrade']
    : null;

  const ctaList = [];

  if (cardInfo.isCardMemberCard) {
    const addEmpProps = { cardInfo, links };

    ctaList.push({
      Component: 'button',
      className: styles.addEmpCtaOuterWrap,
      text: <AddEmployeeCta {...addEmpProps} />,
      $type: 'tertiary'
    });
  }

  const data = {
    ctas: ctaList,
    disclaimerLinks:
      shortName === 'platinum-delta-skymiles'
        ? buildDisclaimerList(links, deltaEventKey, customTncKeys, true, shortName)
        : buildDisclaimerList(links, HeroEventKey, customTncKeys, false, shortName)
  };

  return (
    <div
      className={clsx(styles.ctaAndLinksWrapper, {
        [styles.needUpgradeCta]: needUpgradeCta
      })}
    >
      <div className={styles.applyUpgradeBox}>
        <ApplyAndUpgradeCtas shortName={shortName} allowUpgradeCta={true} />
      </div>
      <GroupedButtons data={data} $direction={'vertical'} />
    </div>
  );
};
